export const tradeLoyaltyStatuses = {
    BLACKLISTED: 'BLACKLISTED',
    ELIGIBLE: 'ELIGIBLE',
    ENROLLED: 'ENROLLED',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
};

export const tradeStatuses = {
    NA: 'NA',
    SUSPECTED: 'SUSPECTED',
    APPLIED_IN_REVIEW: 'APPLIED_IN_REVIEW',
    APPLIED_NOT_ENOUGH_INFORMATION: 'APPLIED_NOT_ENOUGH_INFORMATION',
    APPLIED_REJECTED: 'APPLIED_REJECTED',
    VERIFIED_PRE_APPROVED: 'VERIFIED_PRE_APPROVED',
    VERIFIED_VETTED: 'VERIFIED_VETTED',
    VERIFIED_FIRMLESS: 'VERIFIED_FIRMLESS',
};

export const designProjectStatuses = {
    ACTIVE: 'ACTIVE',
    DELETED: 'DELETED',
    DRAFT: 'DRAFT',
    NEW: 'NEW',
};

export const profileStatuses = {
    ACTIVE: 'ACTIVE',
    DELETED: 'DELETED',
    NEW: 'NEW',
    PENDING: 'PENDING',
};



// WEBPACK FOOTER //
// ./assets/js/trade/constants.es.js